// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.screenshotFrame--Qdtc1 {
  position: absolute;
  top: 999999px;

  width: 1440px;

  z-index: -1;
}[dir] .screenshotFrame--Qdtc1 {

  background: white;
}[dir=ltr] .screenshotFrame--Qdtc1 {
  right: 999999px;
}[dir=rtl] .screenshotFrame--Qdtc1 {
  left: 999999px;
}
`, "",{"version":3,"sources":["webpack://./src/js/components/ScreenshotAndPdfFrame/styles.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;;EAGb,aAAa;;EAIb,WAAW;AACb,CAVA;;EAOE,iBAAiB;AAGnB,CAVA;EAGE,eAAe;AAOjB,CAVA;EAGE,cAAe;AAOjB","sourcesContent":[".screenshotFrame {\n  position: absolute;\n  top: 999999px;\n  right: 999999px;\n\n  width: 1440px;\n\n  background: white;\n\n  z-index: -1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"screenshotFrame": `screenshotFrame--Qdtc1`
};
export default ___CSS_LOADER_EXPORT___;
